/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

 var adminBarID = '#wpadminbar';
 var adminBarHeight = jQuery(adminBarID).height();

 var fixedHeaderID = '#header';
 var fixedHeaderHeight = jQuery(fixedHeaderID).height();

 var hasScrolled = false;

 var tabletHWidth = 1024;
 var tabletVWidth = 768;
 var mobileWidth = 480;


  function fullScreen(selector, withHeader)
        {
          if(typeof withHeader === 'undefined' || withHeader === null)
          {
            withHeader = true;
          }

          jQuery(selector).width(jQuery(window).width());

          if(withHeader)
          {
            jQuery(selector).height(jQuery(window).height() - adminBarHeight - fixedHeaderHeight);
          }
          else
          {
            jQuery(selector).height(jQuery(window).height() - adminBarHeight); 
          }
        }

        // Toggles class for mobile menu expansion/collapse
        function menuToggle() {
          jQuery('body').toggleClass('menu-open');
          jQuery('.nav-primary').toggleClass('expanded');
          // fullScreen('.nav-primary.expanded .menu-header-menu-container', false);
        }

        fullScreen('.fullscreen', false);
        jQuery(window).resize(function() {
          fullScreen('.fullscreen', false);
          // fullScreen('.nav-primary .menu-header-menu-container', false);
        });

        jQuery('.nav-toggle').on('click', function() {
          menuToggle();
        });

        // Hover over and click animation for dropdown, depending on window width.
    function dropDown() {
      jQuery(".main-nav li").unbind("click").unbind("hover");
        if(jQuery(window).width() >= 979) {
      jQuery(".main-nav li").hover(function () {
        jQuery(this).find(".sub-menu").stop().slideToggle("medium");
      }, function(){
             jQuery(this).find(".sub-menu").stop().slideToggle("medium");
    });
   } else {
      jQuery(".main-nav li").click(function () {
        jQuery(this).find(".sub-menu").stop().slideToggle("medium");
      });
    }
}

dropDown();

      jQuery(window).resize(function() {
        dropDown(); 
      });





    // ROTATION ANIMATION of mobile menu arrow.
function rotateArrow() { 
  jQuery(".fa-angle-down").on('click', function(){
    jQuery(this).find("ul.sub-menu");
    $(this).toggleClass('faactive');
  });
}

rotateArrow();

      jQuery(window).resize(function() {
        rotateArrow(); 
      });



    // jQuery(function() {
    //   jQuery(".fa-angle-down").click(function(){
    //     var test = jQuery(this).find("ul.sub-menu");
    //       if(test.css("display") == "block") {
    //         jQuery(".fa-angle-down").addClass("faactive");
    //       } else {
    //         // jQuery(".fa-angle-down").removeClass("faactive");
    //         alert('hi');
    //       }
    //   });
    // });


        // Flip it upside down after open click. Flip it back after 
        // closing click. (CSS) rotation
        // Maybe also target selector to act if icon is in mobile mode. 





        // Services individual sticky pagination 
        jQuery('.sticky-pagination-container .arrow-container').on('click', function() {
          // if(!jQuery(this).hasClass('expanded'))
          // {
          //   jQuery('.sticky-pagination-container .arrow-container.expanded').removeClass('expanded').closest('.paginator').removeClass('visible');
          // }
          jQuery(this).closest('.paginator').toggleClass('visible');
          jQuery(this).toggleClass('expanded');
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.






